export default __webpack_public_path__ + "static/media/ax.8072e1a7.svg";